import { config } from '@/config/config';
import { ApiClient } from '@/utils/api/api-client';
import { searchRequestTimeoutMs } from '@/utils/consts/search-schedules.consts';

export const searchApiClient = new ApiClient(config.searchApi.url, searchRequestTimeoutMs);
